import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OmsServiceService } from '../services/oms-service.service';
import { TrackOrderComponent } from '../modal-popups/track-order/track-order.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'projects/tools/src/lib/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../environments/environment';
import { ReScheduleItemComponent } from '../modal-popups/re-schedule-item/re-schedule-item.component';
import { ConfirmModalComponent } from '../modal-popups/confirm-modal/confirm-modal.component';
import { GeneratePaymentLinkComponent } from '../modal-popups/generate-payment-link/generate-payment-link.component';
import { ReAllocationComponent } from '../modal-popups/re-allocation/re-allocation.component';


@Component({
  selector: 'app-child-orders-list',
  templateUrl: './child-orders-list.component.html',
  styleUrls: ['./child-orders-list.component.scss']
})
export class ChildOrdersListComponent implements OnInit {

  constructor(public route:ActivatedRoute,private omsServiceService:OmsServiceService,    private modalService: NgbModal, private sharedService: SharedService,private _router:Router,    private SpinnerService: NgxSpinnerService,


  ) { }
  orderDetailsRes:any=[]
  totalRecords:any;
  page = 1;
  pageSize = 20;
  skipRecoreds=0;
  orderId:any;
  checkedOrders: any[] = [];
  mrn:any;
  serviceType:any
  amountPerSession:any;
  totalNoofSesstions:any;
  ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      this.mrn = params.mrn;
      this.serviceType=params.serviceType
    });
    this.getOrdersList(this.orderId);
  }
  getOrderById(orderId,detailUrl) {
    if(detailUrl == 'orders'){
        var url=this._router.createUrlTree(['/escalation-details/' + orderId + '/' + 'careAtHome'])
    }else if(detailUrl == 'opd'){
        var url=this._router.createUrlTree(['/order-details/' + orderId ])
    }
    var myWindow = window.open(url.toString(),orderId)
    myWindow.focus();
  }
  invoiceDownload(Id)
  {
    window.open(environment.prescriptionPrint+Id,'_blank');    
  }

  opentrackOrderModal(orderId) {
    //console.log(this.orderDetailsRes);
    const modalRef = this.modalService.open(TrackOrderComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    modalRef.componentInstance.order_id = orderId;
  }
  pageChange(page){
    this.page=page;
    this.skipRecoreds= this.pageSize * (this.page - 1);
    this.getOrdersList(this.orderId)
  }

  openPaymentLinkModal(buttonType,orderDetails) {
    const modalRef = this.modalService.open(GeneratePaymentLinkComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrdersList(this.orderId);
        this.checkedOrders=[];    
     }

    );
    if(buttonType == 'paymentLink'){
      modalRef.componentInstance.sendPaymentLink=true;
    }
    else if(buttonType == 'generateReceipt'){
      modalRef.componentInstance.generateReceipt=true;
    }
    modalRef.componentInstance.serviceType=orderDetails.order.patientinfo.service_type
    modalRef.componentInstance.order_id = this.orderId;
    modalRef.componentInstance.email =orderDetails.order.patientinfo.email;
    modalRef.componentInstance.contactNumber = orderDetails.order.patientinfo.contact;

    if(orderDetails.order.patientinfo.service_type == '5' || orderDetails.order.patientinfo.service_type == '6' || orderDetails.order.patientinfo.service_type == '8' || orderDetails.order.patientinfo.service_type == '7'){
      // modalRef.componentInstance.noOfSections=orderDetails.order.business['repeats']
      modalRef.componentInstance.noOfSections=this.totalNoofSesstions
      // modalRef.componentInstance.totalPayableAmount=orderDetails.order.payment_info.totalApplicableAmount
      modalRef.componentInstance.totalPayableAmount=orderDetails.payment_info.totalApplicableAmount
      modalRef.componentInstance.remainingPayableAmo=orderDetails.payment_info.payable_amount
    }


  }
  
  // openReAllocateModal(orderDetails,status) {
    
  //   const modalRef = this.modalService.open(ReAllocationComponent);
  //   const closeModelRef = modalRef.result.then(
  //     (res) => {

  //       // this.getOrderDataById(this.id);

  //     });
  //   // modalRef.componentInstance.isAssocInfo = this.assoc_data;
  //   // modalRef.componentInstance.isOfficerAssocInfo = this.officerAssocInfo;
  //   modalRef.componentInstance.isorderDetailsRes = orderDetails
  //   modalRef.componentInstance.isSendStatus = status;
  // }

  openReAllocateModal(status) {
    
    const modalRef = this.modalService.open(ReAllocationComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        // this.getOrderDataById(this.id);
        this.getOrdersList(this.orderId);
        this.checkedOrders=[];
        this.selectAll=false

      });
      if(status == 'forceAllocate'){
        modalRef.componentInstance.orderId=this.checkedOrders
        modalRef.componentInstance.tenantCode=this.orderDetailsRes[0].tenantCode
        modalRef.componentInstance.orgCode=this.orderDetailsRes[0].orgCode
        modalRef.componentInstance.role=this.orderDetailsRes[0].order.orderitem[0].role
        modalRef.componentInstance.isSendStatus = status;
      }else{
        modalRef.componentInstance.isorderDetailsRes = this.orderDetailsRes[0];
        modalRef.componentInstance.isSendStatus = status;
      }
    // modalRef.componentInstance.isAssocInfo = this.assoc_data;
    // modalRef.componentInstance.isOfficerAssocInfo = this.officerAssocInfo;

  }
  
  getOrdersList(orderId:any){
    let payload={
      "actionById": "CHAdmin",
      // "dateFilter": "scheduled_date",
      "action": "OMS/api/operation.php/v1/orderswithcount",
      "type": "post",
      "sortBy": "ase",
      // "limit": this.pageSize,
      // "skip": this.skipRecoreds,
      "mrn":this.mrn+"",
      // "businessId": [this.serviceType],
      "skipTenantValidation": 1,
      "dateFilter": "scheduled_date",
      // "extraFilters":["packageParentAndChild"],
      "order_id":parseInt(orderId),
      "limit":500
    }
    if(this.serviceType == '100'){
      payload['extraFilters']=["packageParentAndChild"]
    }else{
      payload['extraFilters']=["careparentandchild"]
      payload ["businessId"]= [this.serviceType]

    }
    this.SpinnerService.show()
    this.omsServiceService.getOrderDetails(payload).subscribe(
      (res:any) => {
        this.SpinnerService.hide()
        this.orderDetailsRes = res["data"][0]["orderDetails"];
        this.totalNoofSesstions=this.orderDetailsRes[0]?.order?.business?.repeats * this.orderDetailsRes[0]?.order?.business?.sessionsPerDay;
        this.amountPerSession=this.orderDetailsRes[0]?.payment_info.net_amount/this.totalNoofSesstions
        // this.totalRecords = res["data"][0]["countOrder"][0]["count"];
      })
  }

  openCancelModal(orderObj, obj) {
    console.log(`orderObj`, orderObj,obj);
    console.log(this.checkedOrders);
    const modalRef = this.modalService.open(ReScheduleItemComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrdersList(this.orderId);
        this.checkedOrders=[];
        this.selectAll=false
      }
    );
    modalRef.componentInstance.delivery_lat = orderObj.order.patientinfo.delivery_lat;
    modalRef.componentInstance.delivery_lng = orderObj.order.patientinfo.delivery_lng;
    modalRef.componentInstance.pincode = orderObj.order.patientinfo.pincode;
    modalRef.componentInstance.mode_of_service = orderObj.mode_of_service;
    modalRef.componentInstance.order_id = this.checkedOrders; 
    console.log(this.checkedOrders);
    modalRef.componentInstance.order_status = orderObj.order.order_status;
    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.total_amount=orderObj.payment_info.totalApplicableAmount;

    if (obj == 1) {
      modalRef.componentInstance.isReScheduleOrder = true;
      modalRef.componentInstance.isConfirmedOrder = false;
    } else if(obj == 15){
      modalRef.componentInstance.isReqCancelledOrder = true;
    } else if(obj == 16){
      modalRef.componentInstance.isReqReScheduleOrder = true;
    } else {
      modalRef.componentInstance.isReScheduleOrder = false;
      modalRef.componentInstance.isConfirmedOrder = true;
    }
    modalRef.componentInstance.org_code = orderObj.orgCode;
    modalRef.componentInstance.tenant_code = orderObj.tenantCode;

    modalRef.componentInstance.patient_gender = orderObj.order.patientinfo.gender;
    modalRef.componentInstance.patient_mrn = orderObj.order.patientinfo.mrn;
    modalRef.componentInstance.patient_age = orderObj.order.patientinfo.age;
    modalRef.componentInstance.preferred_officer = orderObj.order.provider_info.associate_id;
    modalRef.componentInstance.preferred_time = orderObj.order.patientinfo.scheduled_date;    
    modalRef.componentInstance.isReqStatus = obj;
  }
  
  openReScheduleItemModal(orderObj, obj) {
    console.log(`orderObj`, orderObj,obj);
    
    const modalRef = this.modalService.open(ReScheduleItemComponent);

    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrdersList(this.orderId);
        this.checkedOrders=[];
        this.selectAll=false
      }

    );
    
    modalRef.componentInstance.delivery_lat = orderObj.order.patientinfo.delivery_lat;
    modalRef.componentInstance.delivery_lng = orderObj.order.patientinfo.delivery_lng;
    modalRef.componentInstance.pincode = orderObj.order.patientinfo.pincode;
    modalRef.componentInstance.mode_of_service = orderObj.mode_of_service;
    modalRef.componentInstance.order_id = this.checkedOrders;
    modalRef.componentInstance.order_status = orderObj.order.order_status;
    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.total_amount=orderObj.payment_info.paid_amount;
    if (obj == 1) {
      modalRef.componentInstance.isReScheduleOrder = true;
      modalRef.componentInstance.isConfirmedOrder = false;
    } else if(obj == 15){
      modalRef.componentInstance.isReqCancelledOrder = true;
    } else if(obj == 16){
      modalRef.componentInstance.isReqReScheduleOrder = true;
    } 
    else if(obj == 8){
      modalRef.componentInstance.isCancelOrder = true;
    } else {
      modalRef.componentInstance.isReScheduleOrder = false;
      modalRef.componentInstance.isConfirmedOrder = true;
    }
    modalRef.componentInstance.org_code = orderObj.orgCode;
    modalRef.componentInstance.tenant_code = orderObj.tenantCode;

    modalRef.componentInstance.patient_gender = orderObj.order.patientinfo.gender;
    modalRef.componentInstance.patient_mrn = orderObj.order.patientinfo.mrn;
    modalRef.componentInstance.patient_age = orderObj.order.patientinfo.age;
    modalRef.componentInstance.preferred_officer = orderObj.order.provider_info.associate_id;
    modalRef.componentInstance.preferred_time = orderObj.order.patientinfo.scheduled_date;    
    modalRef.componentInstance.isReqStatus = obj;

  }
  selectAll:boolean=false;
  selectAllOrders(event:any){
    this.checkedOrders=[]
    this.orderDetailsRes.map((data:any)=>{
      if(event.target.checked && data?.order?.order_status?.order_status != 8 && data?.order?.order_status?.order_status != 15 && data?.order?.order_status?.order_status != 6 ){
        this.checkedOrders.push(data.order.patientinfo.order_id);
        data.checked=true
      }else{
        data.checked=false
      } 
    })
  }
  updateCheckedOrders(orderDetailsObj: any) {
    if (orderDetailsObj.checked) {
      this.checkedOrders.push(orderDetailsObj.order.patientinfo.order_id);
    } else {
      const index = this.checkedOrders.indexOf(orderDetailsObj.order.patientinfo.order_id);
      if (index > -1) {
        this.checkedOrders.splice(index, 1);
      }
    }
  }

  openCompleteModal(orderId,obj,status) {
    const modalRef = this.modalService.open(ConfirmModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrdersList(this.orderId);
        this.checkedOrders=[];
        this.selectAll=false
      }
    );
      modalRef.componentInstance.order_id = this.checkedOrders;
    if (obj == 2) {
      modalRef.componentInstance.isEconConfirmedOrder = true;
    }else if(obj == 3){
      modalRef.componentInstance.isAtHomeStatus = status;
      modalRef.componentInstance.isAtHomeOrder = true;
    }

  }
}
